import { render, staticRenderFns } from "./MyUserProfileUsageReport.vue?vue&type=template&id=40f7f735"
import script from "./MyUserProfileUsageReport.vue?vue&type=script&lang=ts"
export * from "./MyUserProfileUsageReport.vue?vue&type=script&lang=ts"
import style0 from "./MyUserProfileUsageReport.vue?vue&type=style&index=0&id=40f7f735&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports